<template>
  <main class="main main--help">
    <div class="help">
      <div class="help__content">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1 mb2 mt0"
          v-html="content.title"/>
        <p class="p " v-html="content.bodyCopy"/>
        <div v-html="content.share"/>
        <module-button
          button="secondary"
          link="support"
          label="Go back"
        />
      </div>
      <div class="help__img">
        <img :src="illustration" alt="">
      </div>
    </div>

  </main>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

import store from 'store';

import help from 'images/illustrations/help.png';

// Images
const illustration = help;

export default {
  name: 'others-help',

  // Data
  data() {
    return {
      illustration,
      family: {
        title: 'Getting help for someone&nbsp;else',
        bodyCopy: `We take privacy seriously. If you are seeking care for a partner or someone else who is eligible for ${store.state.app.org.program_name} services through your employer, that person needs to register for services themselves`,
        share:
          `<p class="p mb0">Share how to get services:</p>
          <p class="p mb0 mt0">Website: <a href="${store.state.app.org.share_url}" class="fw-bold">${store.state.app.org.share_url}</a></p>
          <p class="p mb0 mt0">Number: <span class="fw-bold"><a class="tdn" href="tel:${store.state.app.org.phone}">${store.state.app.org.phone}</a><span></p>`,
      },
      coWorker: {
        title: 'Getting help for your co&#8209worker',
        bodyCopy: `Our ${store.state.app.org.program_name} care team has certified counselors available 24/7 to help direct your co-worker to the resources we offer, and if you’re a manager, they can provide guidance on the best way for you to support your employees. Just call us at <span class="fw-bold"><a class="tdn" href="tel:${store.state.app.org.phone}">${store.state.app.org.phone}</a><span>.`,
        share: `<p class="p mb0 mt0">If you feel comfortable to recommend ${store.state.app.org.program_name} directly to your employee just share the number above or this website <a href="${store.state.app.org.share_url}" class="fw-bold">${store.state.app.org.share_url}</a></p>`,
      },
    };
  },

  // Computed
  computed: {
    ...mapGetters('app', [
      'org',
    ]),
    content() {
      return this.$route.params.id === 'co-worker' ? this.coWorker : this.family;
    },
  },
};
</script>



// WEBPACK FOOTER //
// OthersHelp.vue?f5ad410c